import { render, staticRenderFns } from "./NewOneLayer.vue?vue&type=template&id=1aed50c0&scoped=true"
import script from "./NewOneLayer.vue?vue&type=script&lang=js"
export * from "./NewOneLayer.vue?vue&type=script&lang=js"
import style0 from "./NewOneLayer.vue?vue&type=style&index=0&id=1aed50c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed50c0",
  null
  
)

export default component.exports